import {useState, useRef} from 'react'
import {Map, fromJS} from 'immutable'
import PropTypes from 'prop-types'

import ButtonGroup from '../../../../../shared_components/core/buttons/ButtonGroup'
import {Cancel, Accept} from '../../../../../dashboard/src/components/blocks/Buttons'
import Closer from '../../../../../shared_components/core/closer/Closer'
import Modals from '../../../../../shared_components/core/modals/Modals'
import ItemPermissionsSelectForm from '../../../../../shared_components/item_permissions/ItemPermissionsSelectForm'
import {ModalHeader} from '../../../../../shared_components/core/modals/ModalHeaders'
import Fields from '../../../../../shared_components/forms/v2/fields/index'
import Form from '../../../../../shared_components/forms/v2/Form'

import './requestItemPermissionsModal.scss'

const BaseRequestItemPermissionsModal = props => {
  const {
    onConfirm,
    confirmationText,
    requireItemPermissionSelection,
    ownership,
    itemPermissionIds,
    showDefaultSettings,
    onSaveDefaultSettings
  } = props
  const [showModal, setShowModal] = useState(false)
  const [checkedItemIds, setCheckedItemIds] = useState(itemPermissionIds || [])
  const formRef = useRef(null)

  const toggleModal = () => {
    setShowModal(!showModal)
    setCheckedItemIds(itemPermissionIds || [])
  }

  const handleConfirm = () => {
    if (showDefaultSettings && onSaveDefaultSettings && formRef.current &&
        !formRef.current.formData().getIn(['default-item-permissions-checkbox', 'value']).isEmpty())
      onSaveDefaultSettings(checkedItemIds)


    onConfirm(checkedItemIds)
    toggleModal()
  }

  const closer = () => <Closer closer={toggleModal} />

  return (
    <span className='request-item-permissions-modal forms-playground'>
      <a className='item-permissions-modal-link' onClick={toggleModal}>
        Manage permission
      </a>
      <Modals.FullHeightModalLarge
        showModal={showModal}
        closerComponent={closer}>
        <ModalHeader
          heading='For which sections would you like permission to edit?'
          note="Note: some sections may be restricted by your firm's compliance settings."
        />
        <ItemPermissionsSelectForm
          checkedItemIds={checkedItemIds}
          onCheck={setCheckedItemIds}
          permittedItemIds={ownership.get('manageable-edit-item-ids')}
        />

        <ButtonGroup>
          <Cancel onClick={toggleModal} />
          <Accept
            onClick={handleConfirm}
            disabled={requireItemPermissionSelection && !checkedItemIds.length}>
            {confirmationText}
          </Accept>
        </ButtonGroup>
        {showDefaultSettings && (
          <Form className='core' ref={formRef}>
            <Fields.CheckboxList
              data={
                fromJS({
                  id: 'default-item-permissions-checkbox',
                  items: [{value: 'true', label: 'Save as default settings'}],
                  name: 'default-item-permissions-checkbox',
                  value: []
                })
              }
            />
          </Form>
        )}
      </Modals.FullHeightModalLarge>
    </span>
  )
}

BaseRequestItemPermissionsModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  confirmationText: PropTypes.string,
  requireItemPermissionSelection: PropTypes.bool,
  ownership: PropTypes.instanceOf(Map).isRequired,
  itemPermissionIds: PropTypes.array,
  showDefaultSettings: PropTypes.bool,
  onSaveDefaultSettings: PropTypes.func
}

BaseRequestItemPermissionsModal.defaultProps = {
  confirmationText: 'Save',
  showDefaultSettings: false
}

export default BaseRequestItemPermissionsModal
